import { AxiosError } from "axios";
import { IBrand } from "../../../Models/IBrand";
import { IBrandSampleSet } from "../../../Models/IBrandSampleSet";
import { IGetBrandsSampleSetDataByClosestRequest } from "../../../Models/Requests/IGetBrandsSampleSetDataByClosestRequest";
import { IGetBrandsSampleSetDataByGeoRequest } from "../../../Models/Requests/IGetBrandsSampleSetDataByGeoRequest";
import {
    GetAllBrandsFailureAction,
    GetAllBrandsInitiateAction,
    GetAllBrandsSuccessAction,
    GetBrandSampleSetLocationsByClosestFailureAction,
    GetBrandSampleSetLocationsByClosestInitiateAction,
    GetBrandSampleSetLocationsByClosestSuccessAction,
    GetBrandSampleSetLocationsByGeoFailureAction,
    GetBrandSampleSetLocationsByGeoInitiateAction,
    GetBrandSampleSetLocationsByGeoSuccessAction,
    GET_ALL_BRANDS_FAILURE,
    GET_ALL_BRANDS_INITIATE,
    GET_ALL_BRANDS_SUCCESS,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_FAILURE,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_INITIATE,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_SUCCESS,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_FAILURE,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_INITIATE,
    GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_SUCCESS,
    SetLoadingBrandsAction,
    SetLoadingBrandSampleSetLocationsAction,
    SET_LOADING_BRANDS,
    SET_LOADING_BRAND_SAMPLE_SET_LOCATIONS,
    ResetBrandSampleSetAction,
    RESET_BRAND_SAMPLE_SET,
} from "../Types/BrandActionTypes";

/** misc */
export const setLoadingBrands = (loading: boolean): SetLoadingBrandsAction => ({
    type: SET_LOADING_BRANDS,
    data: loading,
});

export const setLoadingBrandSampleSetLocations = (
    loading: boolean
): SetLoadingBrandSampleSetLocationsAction => ({
    type: SET_LOADING_BRAND_SAMPLE_SET_LOCATIONS,
    data: loading,
});

/** initiate */

export const getBrandSampleSetLocationsByGeoInitiate = (
    request: IGetBrandsSampleSetDataByGeoRequest,
    correlationId: number,
): GetBrandSampleSetLocationsByGeoInitiateAction => ({
    type: GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_INITIATE,
    data: request,
    correlationId,
});

export const getBrandSampleSetLocationsByClosestInitiate = (
    request: IGetBrandsSampleSetDataByClosestRequest,
    correlationId: number,
): GetBrandSampleSetLocationsByClosestInitiateAction => ({
    type: GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_INITIATE,
    data: request,
    correlationId,
});

export const getAllBrandsInitiate = (): GetAllBrandsInitiateAction => ({
    type: GET_ALL_BRANDS_INITIATE,
    data: null,
});

/** success */

export const getAllBrandsSuccess = (brands: IBrand[]): GetAllBrandsSuccessAction => ({
    type: GET_ALL_BRANDS_SUCCESS,
    data: brands,
});

export const getBrandSampleSetLocationsByGeoSuccess = (
    sampleSet: IBrandSampleSet[],
    correlationId: number,
): GetBrandSampleSetLocationsByGeoSuccessAction => ({
    type: GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_SUCCESS,
    data: sampleSet,
    correlationId,
});

export const getBrandSampleSetLocationsByClosestSuccess = (
    sampleSet: IBrandSampleSet[],
    correlationId: number,
): GetBrandSampleSetLocationsByClosestSuccessAction => ({
    type: GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_SUCCESS,
    data: sampleSet,
    correlationId,
});

/** failure */

export const getAllBrandsFailure = (error: AxiosError): GetAllBrandsFailureAction => ({
    type: GET_ALL_BRANDS_FAILURE,
    data: error.message,
});

export const getBrandSampleSetLocationsByGeoFailure = (
    error: AxiosError,
    correlationId: number,
): GetBrandSampleSetLocationsByGeoFailureAction => ({
    type: GET_BRAND_SAMPLE_SET_LOCATIONS_BY_GEO_FAILURE,
    data: error.message,
    correlationId,
});

export const getBrandSampleSetLocationsByClosestFailure = (
    error: AxiosError,
    correlationId: number,
): GetBrandSampleSetLocationsByClosestFailureAction => ({
    type: GET_BRAND_SAMPLE_SET_LOCATIONS_BY_CLOSEST_FAILURE,
    data: error.message,
    correlationId,
});

export const resetBrandSampleSet = (
    correlationIdBase,
): ResetBrandSampleSetAction => ({
    type: RESET_BRAND_SAMPLE_SET,
    data: correlationIdBase,
});